import { Component, OnInit, Inject, ViewEncapsulation } from '@angular/core';
import { UtilityService } from '../../../services/utility.service';
import {
  IFunnelStep,
  IFunnelStepVariation,
  IApplication,
} from '../../../interfaces/graph-types';
import { ActivatedRoute, Router } from '@angular/router';
import { DOCUMENT } from '@angular/common';
import { BsModalRef, ModalOptions, BsModalService } from 'ngx-bootstrap/modal';
import { Subscription, Subject, BehaviorSubject } from 'rxjs';
import { SpeedTestService } from 'ng-speed-test';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'proceed',
  template: require('./proceed.component.pug'),
  styles: [
    require('./proceed.component.css').toString(),
    require('../resources/guest.css').toString(),
  ],
  encapsulation: ViewEncapsulation.None,
})
export class GuestProceedComponent implements OnInit {
  csrf = '';

  applicationId: string;

  application: IApplication = null;
  currentStep: IFunnelStepVariation = null;

  bsModalRef: BsModalRef;
  subReason: Subscription = null;
  sub: Subscription = null;

  jobName: string = null;

  isLoading = true;

  internetSpeed: number = null;
  choices = null;

  form: FormGroup;

  errorText = null;

  editor = null;
  editorContent = '';
  initialEditorContent: string = '';
  inputHtml: BehaviorSubject<string> = new BehaviorSubject<string>(null);
  private bodyHtml: string = null;
  private bodyText: string = null;

  public reason: Subject<any>;

  // -------------------------------------------------------------------
  constructor(
    @Inject(DOCUMENT) private document: any,
    private router: Router,
    private route: ActivatedRoute,
    private utilityService: UtilityService,
    private modalService: BsModalService,
    private speedTestService: SpeedTestService,
    fb: FormBuilder,
  ) {
    this.reason = new Subject();
    this.form = fb.group({
      textInput: ['', Validators.required],
    });
  }

  // -------------------------------------------------------------------
  ngOnInit() {
    this.csrf = this.document.querySelector("meta[name='csrf-token']").content;

    const params = this.route.snapshot.params;
    this.applicationId = params['application_id'];

    this.reload(null);

    this.speedTestService.getMbps().subscribe(speed => {
      this.internetSpeed = Math.floor(speed);
      console.log('Your speed is ' + speed);
    });
  }

  // -------------------------------------------------------------------
  ngOnDestroy() {
    if (this.sub) this.sub.unsubscribe();
    if (this.subReason) this.subReason.unsubscribe();
  }

  // -------------------------------------------------------------------
  reload(callback) {
    this.isLoading = true;

    if (this.sub) this.sub.unsubscribe();
    this.sub = this.utilityService
      .getApplicationStep(this.applicationId)
      .subscribe(res => {
        this.application = res;
        this.currentStep = null;
        this.isLoading = false;
        if (this.application) {
          this.currentStep = this.application.currentStepVariation;

          this.jobName = this.application.funnel.jobSpecTitle;

          this.choices = null;
          if (this.currentStep && this.currentStep.choices)
            this.choices = JSON.parse(this.currentStep.choices);

          if (callback) callback();
        }
      });
  }

  // -------------------------------------------------------------------
  toggle(choice) {
    choice.selected = !choice.selected;
  }

  // -------------------------------------------------------------------
  onEditorCreated(quill) {
    this.editor = quill;
  }

  // -------------------------------------------------------------------
  onTextChanged({ html, text, firstUpdate }) {
    this.bodyHtml = html;
    this.bodyText = text;
  }

  // -------------------------------------------------------------------
  continue(data: any, onsuccess: onSmartSuccess, onfailure: onSmartFailure) {
    this.errorText = null;

    let response = this.form.get('textInput').value;

    this.utilityService.continueApplication(
      this.applicationId,
      response,
      res => {
        this.bodyHtml = '';
        this.bodyText = '';

        this.form.setValue({ textInput: '' });

        this.reload(() => {
          onsuccess();
        });
      },
      error => {
        this.errorText = error;
        onfailure(error);
      },
    );
  }

  // -------------------------------------------------------------------
  continueMulti(
    data: any,
    onsuccess: onSmartSuccess,
    onfailure: onSmartFailure,
  ) {
    this.errorText = null;
    let response = [];

    this.choices.forEach(choice => {
      if (choice.selected) {
        response.push(choice.value);
      }
    });

    let explanation = this.form.get('textInput').value;
    this.utilityService.continueApplicationMulti(
      this.applicationId,
      response,
      explanation,
      res => {
        this.bodyHtml = '';
        this.bodyText = '';

        this.form.setValue({ textInput: '' });

        this.reload(() => {
          onsuccess();
        });
      },
      error => {
        this.errorText = error;
        onfailure(error);
      },
    );
  }

  // -------------------------------------------------------------------
  getPath(oauth) {
    // return (
    //   '/auth/' +
    //   oauth +
    //   '?apply=true&account_id=' +
    //   this.accountId +
    //   '&funnel_id=' +
    //   this.funnelId +
    //   '&secret=' +
    //   this.secret
    // );
  }
}
